import { Input } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'

interface NumberProps {}

const Number: FC<NumberProps> = () => {
    const name = 'number'

    return (
        <Form.Item name={name} label={'Номер'}>
            <Input />
        </Form.Item>
    )
}

export default Number
